module.exports = __webpack_public_path__ + "static/media/Jarimeh.aaefdbe4.png";